import styled from "styled-components"

export const CardColumnWithCustomPadding = styled.div`
  @media (min-width: 1024px) {
    margin-right: 16px;
    padding-right: calc(16px + 0.75rem);
  }
`;